import React from 'react';
import { useForm } from 'react-hook-form';

const ApproveModal = ({ client, currentUser, onSubmit, onClose }) => {
  const { register, handleSubmit, formState: { errors } } = useForm();

  return (
    <div className="fixed inset-0 bg-gray-800 bg-opacity-75 flex items-center justify-center z-50">
      <form
        onSubmit={handleSubmit(onSubmit)}
        className="bg-white rounded-xl p-6 w-11/12 md:w-1/2 max-h-[95vh] overflow-y-auto"
      >
        <h2 className="text-xl font-semibold text-gray-900 mb-6">Informations complémentaires</h2>

        {/* Revenue Input */}
        <div className="mb-6">
          <label className="block mb-2 text-sm font-semibold text-gray-700">
            Chiffre d'affaires généré grâce à la vente ?
          </label>
          <div className="flex items-center space-x-4">
            <input
              type="number"
              {...register('revenue', {
                required: 'Ce champ est requis'
              })}
              className="w-full px-3 py-2 text-sm border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-fideliz-blue focus:border-transparent font-medium"
              placeholder="Entrer le montant"
            />
            <span className="text-sm font-medium text-gray-600">€</span>
          </div>
          {errors.revenue && (
            <span className="text-red-500 text-sm">{errors.revenue.message}</span>
          )}
        </div>

        {/* Actions */}
        <div className="flex justify-end mt-8 gap-3">
          <button
            type="button"
            onClick={onClose}
            className="px-4 py-2 text-sm font-semibold bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200 transition-colors"
          >
            Annuler
          </button>
          <button
            type="submit"
            className="px-4 py-2 text-sm bg-fideliz-blue text-white font-semibold rounded-lg hover:bg-fideliz-blue hover:opacity-80 transition-colors"
          >
            Valider
          </button>
        </div>
      </form>
    </div>
  );
};

export default ApproveModal;

